<template>
  <div class="grid-link" :class="iconOnly ? 'max-width' : ''">
    <a
      class="base-link"
      :href="startLink + (link || text)"
      :target="type === 'map' && '_blank'"
      noopener
      noreferrer
      :class="iconOnly ? 'nongrid justify-center' : ''"
    >
      <span v-if="!iconOnly">
        {{ text }}
      </span>
      <IconsBaseLink :icon="type" />
    </a>
    <ButtonCopy v-if="copy && text" :text="text" />
  </div>
</template>

<script>
import IconsBaseLink from '@/components/icons/base/IconsBaseLink'
import ButtonCopy from 'components/ButtonCopy'

export default {
  name: 'BaseLink',
  components: { ButtonCopy, IconsBaseLink },
  props: {
    text: String,
    link: String,
    type: String,
    copy: Boolean,
    iconOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    startLink() {
      let result = ''
      if (this.type === 'tel') {
        result = 'tel:'
      } else if (this.type === 'mail') {
        result = 'mailto:'
      } else if (this.type === 'map') {
        result = 'https://maps.google.com/maps?q='
      }
      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.base-link {
  background: #277faf !important;
  border-radius: 10px;
  padding: 10px !important;
  color: #ffffff;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr auto;
  //justify-content: space-between;
  column-gap: 10px;
  align-items: center;
}

.grid-link {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr auto;
  align-items: center;
  //grid-gap: 30px;
}

.nongrid {
  display: flex;
}

a {
  min-width: 56px !important;
}

span {
  word-wrap: anywhere;
}

.v-btn {
  min-width: 56px !important;
  justify-content: center;
  margin-left: 20px;
}

.max-width {
  max-width: 56px;
}
</style>
